<template>
  <MasterLayout>
    <div class="new-staff w-98">
      <div class="row">
        <div class="col-md-5">
          <div class="add_new_bank_account_header">
            <p>
              {{ mode === "create" ? "Record" : "Edit" }}
              {{ $t("text.bSales.sale") }}
            </p>
          </div>
          <div class="cover">
            <div class="personal">
              <div class="row">
                <div class="mt-4 input__group__block col-md-6">
                  <label class="required">
                    <span class="mylabel">
                      {{ $t("text.bSales.products") }}
                    </span>
                  </label>
                  <div class="e-form price_change_input_wrapper">
                    <model-select
                      :options="products"
                      v-model="product"
                      placeholder="select product"
                    >
                    </model-select>
                  </div>
                </div>
                <div class="mt-4 input__group__block col-md-6">
                  <label class="required">
                    <span class="mylabel">
                      {{ $t("text.bSales.unitPrice") }}
                    </span>
                  </label>
                  <div class="price_change_input_wrapper">
                    <input
                      type="text"
                      placeholder="Unit price"
                      class="border-0"
                      v-model="formData.unitPrice"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="mt-4 input__group__block col-md-6">
                  <label class="required">
                    <span class="mylabel">
                      {{ $t("text.bSales.quantitySold") }}
                    </span>
                  </label>
                  <div class="price_change_input_wrapper">
                    <input
                      type="number"
                      placeholder="Quantity supplied"
                      class="border-0"
                      v-model="formData.quantitySupplied"
                    />
                  </div>
                </div>
                <div class="mt-4 input__group__block col-md-6">
                  <label class="required">
                    <span class="mylabel">
                      {{ $t("text.calendar.date") }}
                    </span>
                  </label>
                  <div class="price_change_input_wrapper">
                    <vue-ctk-date-time-picker
                      v-model="startDate"
                      :max-date="maxDate"
                      :onlyDate="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :color="$store.getters.getDatePickerColor"
                      format="YYYY-MM-DDTHH:mm:ss"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.selectDate')"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="pb-4 mt-4 text-center">
              <button class="ep-btn ep-primary" @click="addSale">
                {{ $t("text.bSales.addSale") }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div v-if="formData.items.length">
            <b-table striped hover :items="formData.items" :fields="fields">
              <template #cell(action)="data">
                <i
                  class="cursor-pointer fa fa-minus-circle red-color"
                  v-b-tooltip.hover
                  title="Remove item"
                  aria-hidden="true"
                  @click="removeSale(data.index)"
                ></i>
              </template>
              <template #cell(price)="data">
                <input
                  type="text"
                  class="form-control"
                  v-model="formData.items[data.index].price"
                />
              </template>
              <template #cell(quantity)="data">
                <input
                  type="number"
                  class="form-control"
                  v-model="formData.items[data.index].quantity"
                />
              </template>
            </b-table>
            <div class="mt-3 text-right">
              <div class="display-flex align-items-center justify-content-end">
                <h6 class="mr-2 font-bold">{{ $t("text.bSales.totQty") }}</h6>
                <h6>{{ totalQuantity }}</h6>
              </div>
              <div class="display-flex align-items-center justify-content-end">
                <h6 class="mr-2 font-bold">{{ $t("text.bSales.totPrice") }}</h6>
                <h6>
                  {{ branch ? branch.currencyCode : "" }}
                  {{
                    totalPriceWithDiscount
                      ? convertThousand(totalPriceWithDiscount)
                      : convertThousand(totalPrice)
                  }}
                </h6>
              </div>
            </div>
            <div class="mt-3 row">
              <div class="col-md-8"></div>
              <div class="text-right col-md-4">
                <div
                  class="display-flex align-items-center justify-content-end"
                >
                  <input
                    type="checkbox"
                    class="mr-2"
                    :checked="formData.applyDiscount"
                    v-model="formData.applyDiscount"
                  />
                  <span>{{ $t("text.bSales.applyDiscount") }}</span>
                </div>
                <div v-if="formData.applyDiscount">
                  <label>{{ $t("text.bSales.enterDiscountAmt") }}</label>
                  <input
                    type="number"
                    placeholder="Discount amount"
                    class="form-control"
                    v-model="formData.discount"
                  />
                </div>
                <div>
                  <label>{{ $t("text.bSales.enterCustomerName") }}</label>
                  <input
                    type="text"
                    placeholder="Customer name"
                    class="form-control"
                    v-model="formData.customerName"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3 text-right" v-if="formData.items.length">
            <button class="btn btn-warning" @click="createSale($event)">
              {{ mode === "create" ? "Create" : "Update" }} Sale
              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="35px"
                class="ml-3 loader"
              />
            </button>
          </div>
          <div class="empty-info-wrapper new-row" v-if="!formData.items.length">
            <img src="@/assets/img/box-grayed.png" width="50" />
            <p class="mt-5 light-grey-text">
              {{ $t("text.bSales.addSalesWarning") }}
            </p>
            <small class="light-grey-text">{{
              $t("text.bSales.suppWillAdd")
            }}</small>
            <div class="mt-5"></div>
          </div>
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "AddStaff",
  components: {
    MasterLayout,
    VueTagsInput,
    PulseLoader,
    ModelSelect,
  },
  data() {
    return {
      catId: null,
      isButtonDisabled: false,
      showLoader: true,
      description: null,
      supplyObj: {
        quantitySold: null,
      },
      products: [],
      product: null,
      mode: "create",
      saleId: null,
      branch: null,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      fields: [
        {
          key: "product",
          label: "Product",
          class: "text-center",
        },
        { key: "price", label: `Price`, class: "text-center" },
        { key: "quantity", label: "Quantity", class: "text-center" },
        { key: "totalPrice", label: "Total price", class: "text-center" },
        { key: "action", label: "Action", class: "text-center" },
      ],
      formData: {
        discount: null,
        items: [],
        applyDiscount: false,
        unitPrice: null,
        quantitySupplied: null,
        customerName: null,
        totalPrice: null,
      },
      totalPriceWithDiscount: null,
      productIds: [],
    };
  },
  beforeCreate() {},
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Create Branch Non Wet products Sale :: ${branch.name} Retail Outlet`;
    });

    document.title = "Create Non wet Product sale:: Epump Company";

    if (this.$route.query.saleId) {
      window.localStorage.removeItem("nonWetBranchProductSales");
      window.localStorage.removeItem("nonWetBranchProductIds");
      this.mode = "edit";
      this.saleId = this.$route.query.saleId;
      this.getSale();
    }
    if (this.$route.query.discountPrice && this.$route.query.customer) {
      this.formData = {
        ...this.formData,
        discount: this.$route.query.discountPrice,
        customerName: this.$route.query.customer,
        applyDiscount: true,
      };
    }
  },
  mounted() {
    if (window.localStorage.getItem("nonWetBranchProductSales")) {
      this.formData.items = JSON.parse(
        localStorage.getItem("nonWetBranchProductSales")
      );
      this.productIds = JSON.parse(
        localStorage.getItem("nonWetBranchProductIds")
      );
    }
  },
  beforeDestroy() {},
  computed: {
    totalPrice: {
      get() {
        if (this.formData.items.length) {
          return this.formData.items.reduce((acc, cur) => {
            const totalPrice =
              parseFloat(cur.price.replace(/,/g, "")) * cur.quantity;
            return (acc += totalPrice);
          }, 0);
        } else {
          return 0;
        }
      },
      set(value) {
        this.totalPriceWithDiscount = value;
      },
    },
    totalQuantity: {
      get() {
        if (this.formData.items.length) {
          return this.formData.items.reduce(
            (acc, cur) => (acc += Number(cur.quantity)),
            0
          );
        } else {
          return 0;
        }
      },
      set(value) {},
    },
  },
  watch: {
    formData: {
      handler(formData) {
        if (formData.items) {
          formData.items.forEach((fData, index) => {
            this.formData.items[index].totalPrice = this.convertThousand(
              Number(this.formData.items[index].price) *
                Number(this.formData.items[index].quantity)
            );
          });
        }
        if (formData.discount) {
          this.totalPrice = this.totalPrice - formData.discount;
        } else {
          this.totalPriceWithDiscount = this.totalPrice;
        }
      },
      deep: true,
    },
    product() {
      const product = this.products.filter(
        (product) => product.id === this.product
      )[0];
      this.formData = {
        ...this.formData,
        quantitySupplied: product.quantityAvailable,
        unitPrice: product.unitPrice,
      };
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getNonWetProduct();
        }
      }
    },
  },
  methods: {
    removeSale(index) {
      this.formData.items.splice(index, 1);
      this.productIds.splice(index, 1);
      window.localStorage.setItem(
        "nonWetBranchProductSales",
        JSON.stringify(this.formData.items)
      );
      window.localStorage.setItem(
        "nonWetBranchProductIds",
        JSON.stringify(this.productIds)
      );
    },
    addSale($event) {
      $event.preventDefault();
      if (!this.formData.unitPrice) {
        this.$toast.open({
          message: this.$t("text.bSales.reqUnitPrice"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.quantitySupplied) {
        this.$toast.open({
          message: this.$t("text.bSales.reqUnitQty"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.product) {
        this.$toast.open({
          message: this.$t("text.bSales.reqUnitProd"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      const product = this.products.filter(
        (product) => product.id === this.product
      )[0];
      let price = this.formData.unitPrice;
      let quantity = this.formData.quantitySupplied;
      let totalPrice = this.convertThousand(Number(price) * Number(quantity));

      this.productIds.push(product.id);

      this.formData.items.push({
        product: product.name,
        quantity: Number(this.formData.quantitySupplied),
        price: this.convertThousand(Number(this.formData.unitPrice)),
        totalPrice,
      });
      this.product = null;
      this.formData.quantitySupplied = null;
      this.formData.unitPrice = null;

      window.localStorage.setItem(
        "nonWetBranchProductSales",
        JSON.stringify(this.formData.items)
      );
      window.localStorage.setItem(
        "nonWetBranchProductIds",
        JSON.stringify(this.productIds)
      );
    },
    createSale($event) {
      $event.preventDefault();
      const items = this.formData.items.map((item, index) => {
        const productId = this.productIds[index];
        return {
          productID: productId,
          unitSold: item.quantity,
          soldPrice: parseFloat(item.price.replace(/,/g, "")),
        };
      });

      let payload = {
        productsSold: items,
        saleDiscount: parseFloat(this.formData.discount),
        customerName: this.formData.customerName,
        salesDate: this.startDate,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/NonWetProductSales/AddSales/${this.branch.id}`,
          payload,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.bSales.salesAdded"),
            type: "success",
            duration: 5000,
          });
          window.localStorage.removeItem("nonWetBranchProductSales");
          window.localStorage.removeItem("nonWetBranchProductIds");
          this.$router.push({
            name: "NonWetProductsBranchSales",
            query: { ...this.$route.query },
          });
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    getNonWetProduct() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/NonWetProduct/Product/Branch/${this.branch.id}/All`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          response.data.forEach((el, i) => {
            el.text = el.name;
            el.value = el.id;
          });
          this.products = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getSale() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/NonWetProductSales/Sales/Detail/${this.saleId}`,
          configObject.authConfig()
        )
        .then((response) => {
          const data = response.data.map((data, index) => {
            this.productIds[index] = data.nonWetProductId;
            return {
              product: data.nonWetProductName,
              quantity: data.quantitySold,
              price: this.convertThousand(
                data.totalSoldPrice / data.quantitySold
              ),
              totalPrice: this.convertThousand(data.totalSoldPrice),
            };
          });
          this.formData.items = data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    updateSale($event) {
      $event.preventDefault();
      if (!this.supplyObj.quantitySold) {
        this.$toast.open({
          message: this.$t("text.bSales.reqQtySold"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.supply) {
        this.$toast.open({
          message: this.$t("text.bSales.reqSupplyTo"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      let payload = {
        nonWetProductSupplyID: this.supply,
        quantitySold: parseFloat(this.supplyObj.quantitySold),
      };

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .put(
          `${configObject.apiBaseUrl}/NonWetProductSales/UpdateSales/${this.branch.id}/${this.saleId}`,
          payload,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.bSales.salesUpdated"),
            type: "success",
            duration: 5000,
          });
          // this.$router.push({name: 'NonWetProductsBranchSales', query: {companyId: this.$route.query.companyId, branchId: this.$route.query.branchId}})
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
